import React, { useEffect, useState } from 'react';
import classNames from 'classnames';

import { formatCurrency } from '../../lib/formatters';

export default function TermItem({
  parentSelectedTerm,
  setParentTerm,
  term,
  children
}) {
  const [selectedTerm, setSelectedTerm] = useState({ term: null, term_period: null, payment: null });

  useEffect(() => {
    if (setParentTerm) setParentTerm(selectedTerm);
  }, [selectedTerm]);

  const termOnClick = (term) => {
    setSelectedTerm({
      term: parseInt(term.get('term')),
      term_period: term.get('term_period'),
      payment: parseFloat(term.get('monthly_payment'))
    });
  };

  return (
    <div
      style={styles.monthlyPaymentsDiv}
      className={classNames("mb-4 term-container", {
        'term-available': term.get('available'),
        'term-unavailable': !term.get('available'),
        'selected': term.get('available') && parentSelectedTerm && term.get('term') === parentSelectedTerm.term
      })}
      key={term.get('term')}
      id={"term-" + term.get('term')}
      data-term={term.get('term')}
      data-payment={formatCurrency(term.get('monthly_payment'))}
      onClick={() => termOnClick(term)}
    >
      {children}
    </div>
  )
}

const styles = {
  fourPaymentsContainer: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-evenly',
    paddingTop: '0.3rem'
  },
  paymentsInterest: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between'
  },
  circleIcon: { fontSize: '.3em' },
  orderFee: { whiteSpace: 'nowrap' },
  payOverTimeDiv: {
    width: '100%',
    height: '17px',
    borderBottom: '2.6px solid black',
    textAlign: 'center',
    marginTop: '2rem'
  },
  orPay: { backgroundColor: 'white', padding: '1.2em' },
  earlyPay: { padding: '1.1rem' },
  monthlyPaymentsDiv: { padding: '1.5rem', margin: '1.3rem auto' },
}
